export default "__VITE_ASSET__C$h$KqzH__"